module.exports = __webpack_public_path__ + "static/media/b-sci-major-5_LR.cfd7e059.jpg";